import React from "react";
import { useLocation } from "react-router-dom";
import { Steps } from "./steps";
import { Step1 } from "./step-1";
import { Step2 } from "./step-2";
import { Step3 } from "./step-3";
import { Step4 } from "./step-4";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";

const formSteps = [
  {
    id: 1,
    label: <FormattedMessage id="step.anuncio" defaultMessage="Anúncio" />,
  },
  {
    id: 2,
    label: <FormattedMessage id="step.gestao" defaultMessage="Gestão" />,
  },
  {
    id: 3,
    label: (
      <FormattedMessage id="step.divulgacao" defaultMessage="Divulgação" />
    ),
  },
  {
    id: 4,
    label: (
      <FormattedMessage id="step.confirmacao" defaultMessage="Confirmação" />
    ),
  },
];

export function Forms({ formState, setFormState }) {
  const [selectedStepId, setSelectedStepId] = React.useState(1);
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  // ✅ criando uma vaga do zero: começa no step 1.
  // criando uma vaga a partir de modelo ou recorrente, duas formas:
  //  - ✅ começa no 1 e clica em "usar vaga" que leva para o 4.
  //  - ✅ clica em um card e vai direto para o 4.
  // ✅ criando uma vaga modelo do zero: começa no step 1.
  // ✅ criando uma vaga modelo a partir de modelo ou recorrente: começa no 1 e clica em "usar vaga" que leva para o 4.
  // ✅ editando uma vaga: começa no step 4.
  // ✅ editando uma vaga modelo: começa no step 4.

  React.useEffect(() => {
    setFormState({
      vagaId: query.get("fromId") ?? query.get("vaga-id") ?? "",
    });

    if (
      query.get("fromId") ||
      query.get("vaga-id") ||
      location.pathname?.includes("/editar-processo") ||
      location.pathname?.includes("/editar-vaga-modelo")
    )
      setSelectedStepId(4);
  }, []);

  return (
    <>
      <Steps
        items={formSteps}
        selectedId={selectedStepId}
        onSelectedIdChange={(stepId) => setSelectedStepId(stepId)}
      />

      {selectedStepId === 1 ? (
        <Step1
          formState={formState}
          setFormState={setFormState}
          setSelectedStepId={setSelectedStepId}
        />
      ) : null}
      {selectedStepId === 2 ? (
        <Step2
          formState={formState}
          setFormState={setFormState}
          setSelectedStepId={setSelectedStepId}
        />
      ) : null}
      {selectedStepId === 3 ? (
        <Step3
          formState={formState}
          setFormState={setFormState}
          setSelectedStepId={setSelectedStepId}
        />
      ) : null}
      {selectedStepId === 4 ? (
        <Step4
          formState={formState}
          setFormState={setFormState}
          setSelectedStepId={setSelectedStepId}
        />
      ) : null}
    </>
  );
}
